import React, { useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import { KeepAspectRatio, GameScoreInputs, Dots } from '../..';
import Menu from './Menu';
import './VideoPreview.scss';

const VideoPreview = ({
  videoContainer,
  onDelete,
  onDownload,
  onClick,
  changeGameTitle,
  updateAwayScore,
  updateHomeScore,
  onShare, 
  onAssignAssistant
}) => {
  const {
    video,
    info: { score },
    title,
    insertionDate,
    _id, 
    team: { name }
  } = videoContainer;

  const [newTitle, setNewTitle] = useState(title);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const displayedDate = dayjs(insertionDate).format("MMM DD, YYYY");

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  }

  const handleNewGameTitle = () => {
    changeGameTitle(_id, newTitle);
  };

  const handleUpdateAwayScore = awayScore => {
    updateAwayScore(_id, awayScore);
  };

  const handleUpdateHomeScore = homeScore => {
    updateHomeScore(_id, homeScore);
  };
  
  return (
    <div className="video-preview">
      <KeepAspectRatio adjustAcordingToWidth>
        <button className="video-preview__button" onClick={onClick}>
          <img
            className="video-preview__button__image"
            src={video.thumbnailUri}
            alt=""
          />
        </button>
        <Menu
          isVisible={isMenuOpen}
          onDeleteClick={() => onDelete(videoContainer)}
          onDownloadClick={() => onDownload(videoContainer)}
          onShareClick={() => onShare(videoContainer)}
          onAssignClick={()=> onAssignAssistant(videoContainer)}
        />
      </KeepAspectRatio>
      <div className="video-preview__footer">
        <div className="video-preview__footer__main">
          <span className="video-preview__footer__main__team-name">{name}</span>
          <input
            className="video-preview__footer__main__input"
            value={newTitle}
            placeholder="Add Game Title"
            disabled={!!title}
            onChange={event => setNewTitle(event.target.value)}
            onBlur={handleNewGameTitle}
          />
          <div className="video-preview__footer__main__date-score">
            <span className="video-preview__footer__main__date-score__date">{displayedDate}</span>
            <GameScoreInputs
              score={score}
              updateHomeScore={handleUpdateHomeScore}
              updateAwayScore={handleUpdateAwayScore}
              isEditable={!score.home && !score.away}
            />
          </div>
        </div>
        <button
          type="button"
          className="video-preview__footer__menu-icon"
          onClick={handleMenuClick}
        >
          <Dots length={3} isHorizontal={isMenuOpen} />
        </button>
      </div>
    </div>
  );
};

VideoPreview.propTypes = {
  changeGameTitle: PropTypes.func,
  onAssignAssistant: PropTypes.func, 
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  onDownload: PropTypes.func,
  onShare: PropTypes.func, 
  updateAwayScore: PropTypes.func,
  updateHomeScore: PropTypes.func,
  videoContainer: PropTypes.object 
};

VideoPreview.defaultProps = {
  changeGameTitle: ()=> {},
  onAssignAssistant: ()=> {},
  onClick: ()=> {},
  onDelete: ()=> {},
  onDownload: ()=> {},
  onShare: ()=> {}, 
  updateAwayScore: ()=> {},
  updateHomeScore: ()=> {},
  videoContainer: {} 
};

export default VideoPreview;
